import { SessionJoinState } from "../enums/SessionJoinState";

export const getSessionJoinState = (state: string): SessionJoinState => {
  switch (state) {
    case "nothing_yet":
      return SessionJoinState.NothingYet;
    case "early":
      return SessionJoinState.Early;
    case "join_now":
      return SessionJoinState.JoinNow;
    case "missed":
      return SessionJoinState.Missed;
    case "ended":
      return SessionJoinState.Ended;
    case "rejoin":
      return SessionJoinState.ReJoin;
    default:
      return SessionJoinState.NothingYet;
  }
};
